import { atom } from "recoil";

export const statisticsDataState = atom({
  key: "statisticsDataState",
  default: [],
});
